import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category/japanese' },
    { label: '热门推荐', path: '/category/story' },
    { label: '关于我们', path: '/about' },
  ],
  分类推荐: [
    { label: '日本h漫', path: '/category/japanese' },
    { label: '汉化h漫', path: '/category/chinese-translated' },
    { label: '同人h漫', path: '/category/doujin' },
    { label: '3D h漫', path: '/category/3d' },
    { label: '全彩h漫', path: '/category/full-color' },
  ],
  精选频道: [
    { label: '剧情h漫', path: '/category/story' },
    { label: '短篇h漫', path: '/category/short' },
    { label: '连载h漫', path: '/category/serialized' },
    { label: '年度精选', path: '/article/2024-top-h-manga-recommendations' },
    { label: '入门指南', path: '/article/doujin-h-manga-beginner-guide' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        {/* Top Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-heart-fill text-lg text-white"></i>
              </div>
              <span className="text-xl font-heading text-white">h漫导航</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              精选h漫资源导航与推荐平台，提供专业的h漫导览、热门作品推荐及相关文化解读。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2024 h漫导航. 本站为h漫资源导航与推荐平台，不存储任何内容。所有作品版权归原作者所有。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
                使用条款
              </a>
              <Link to="/about" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}